import { MjmlColumn, MjmlRaw, MjmlSection } from "@faire/mjml-react";
import {
  Section,
  SharedProps,
  SocialPlatform,
  widthPixelsToPercentage,
} from "@redotech/redo-model/email-builder";
import { memo } from "react";

export type SocialsState = Section.Socials & SharedProps;

const SocialsIcon = {
  [SocialPlatform.APPLE]:
    "https://assets.getredo.com/email-social-icons/social-icon-apple.png",
  [SocialPlatform.DISCORD]:
    "https://assets.getredo.com/email-social-icons/social-icon-discord.png",
  [SocialPlatform.FACEBOOK]:
    "https://assets.getredo.com/email-social-icons/social-icon-facebook.png",
  [SocialPlatform.GITHUB]:
    "https://assets.getredo.com/email-social-icons/social-icon-github.png",
  [SocialPlatform.GOOGLE]:
    "https://assets.getredo.com/email-social-icons/social-icon-google.png",
  [SocialPlatform.INSTAGRAM]:
    "https://assets.getredo.com/email-social-icons/social-icon-instagram.png",
  [SocialPlatform.LINKEDIN]:
    "https://assets.getredo.com/email-social-icons/social-icon-linkedin.png",
  [SocialPlatform.PINTEREST]:
    "https://assets.getredo.com/email-social-icons/social-icon-pinterest.png",
  [SocialPlatform.REDDIT]:
    "https://assets.getredo.com/email-social-icons/social-icon-reddit.png",
  [SocialPlatform.SNAPCHAT]:
    "https://assets.getredo.com/email-social-icons/social-icon-snapchat.png",
  [SocialPlatform.TIKTOK]:
    "https://assets.getredo.com/email-social-icons/social-icon-tiktok.png",
  [SocialPlatform.TWITTER]:
    "https://assets.getredo.com/email-social-icons/social-icon-twitter.png",
  [SocialPlatform.YOUTUBE]:
    "https://assets.getredo.com/email-social-icons/social-icon-youtube.png",
};

export const EmailSocials = memo(function EmailSocials(props: SocialsState) {
  const padding = props.sectionPadding;

  return (
    <MjmlSection
      backgroundColor={props.sectionColor}
      paddingBottom={padding.bottom}
      paddingLeft={`${widthPixelsToPercentage(padding.left)}%`}
      paddingRight={`${widthPixelsToPercentage(padding.right)}%`}
      paddingTop={padding.top}
    >
      {props.socialLinks.map((item, index) => {
        const Icon = SocialsIcon[item.platform];

        return (
          <MjmlColumn key={index}>
            <MjmlRaw>
              <div style={{ padding: props.iconPadding, textAlign: "center" }}>
                <a href={item.url} rel="noreferrer" target="_blank">
                  <img height={24} src={Icon} width={24} />
                </a>
              </div>
            </MjmlRaw>
          </MjmlColumn>
        );
      })}
    </MjmlSection>
  );
});
